import { PlanSettings } from "@/app/types/billing/PlanSettings";
import {
  ACTIVE_SUBSCRIPTION_STATUSES,
  SubscriptionData,
} from "@/app/types/billing/SubscriptionData";
import { Credits, Subscription } from "@/app/vars/Credits";

export class UPlan {
  public static activeSubscription(
    subscription: SubscriptionData | null | undefined,
  ): SubscriptionData | null {
    if (!subscription || !ACTIVE_SUBSCRIPTION_STATUSES.includes(subscription.status)) {
      return null;
    }
    return new Date(subscription.currentPeriodEnd) > new Date() ? subscription : null;
  }

  public static monthlyPriceEur(plan: PlanSettings, isAnnual: boolean): number {
    if (!isAnnual) {
      return plan.monthlyPriceEur;
    }
    return Math.round((plan.monthlyPriceEur * (100 - plan.annualDiscountPercent)) / 100);
  }

  public static annualPriceEur(plan: PlanSettings): number {
    return UPlan.monthlyPriceEur(plan, true) * 12;
  }

  public static callAllowanceCredits(plan: PlanSettings): number {
    return plan.callHoursPerMonth * Credits.ANALYSIS_CREDITS_PER_HOUR;
  }

  public static prospectAllowanceCredits(plan: PlanSettings): number {
    return plan.prospectsPerMonth;
  }

  public static planCreditsPerMonth(plan: PlanSettings): number {
    return UPlan.callAllowanceCredits(plan) + UPlan.prospectAllowanceCredits(plan);
  }

  public static topUpUnitPriceEur(plan: PlanSettings): number {
    const included = UPlan.planCreditsPerMonth(plan);
    if (included <= 0) {
      return Credits.UNIT_PRICE_EUR / Credits.UNIT_SIZE;
    }

    const planRate = plan.monthlyPriceEur / included;
    return (planRate * (100 + Subscription.TOPUP_MARKUP_PERCENT)) / 100;
  }

  public static topUpPriceEur(plan: PlanSettings, credits: number): number {
    return Math.round(credits * UPlan.topUpUnitPriceEur(plan));
  }

  public static centsToEur(cents: number): number {
    return Math.round(cents) / 100;
  }

  public static formatEur(cents: number, lang: string): string {
    return new Intl.NumberFormat(lang, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(UPlan.centsToEur(cents));
  }

  public static creditsForHours(hours: number): number {
    return hours * Credits.ANALYSIS_CREDITS_PER_HOUR;
  }
}
